export default __webpack_public_path__ + "static/email-template-8756765b7a9460f9dc81caf4b0490b9f.jpg";